import { FILE_TYPES } from '../constants';

// Determine file type and configuration
export const getFileTypeConfig = (fileName) => {
  const lowerFileName = fileName.toLowerCase();
  
  // Check each file type category
  for (const [category, config] of Object.entries(FILE_TYPES)) {
    if (config.extensions) {
      const matchesExtension = config.extensions.some(ext => 
        lowerFileName.endsWith(ext)
      );
      if (matchesExtension) {
        return { ...config, category };
      }
    }
  }
  
  // Return default if no match found
  return { ...FILE_TYPES.DEFAULT, category: 'DEFAULT' };
};

// Check if file is an image
export const isImageFile = (fileName) => {
  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];
  const lowerFileName = fileName.toLowerCase();
  return imageExtensions.some(ext => lowerFileName.endsWith(ext));
};

// Check if file is a PDF
export const isPDFFile = (fileName) => {
  return fileName.toLowerCase().endsWith('.pdf');
};

// Get file extension
export const getFileExtension = (fileName) => {
  const lastDotIndex = fileName.lastIndexOf('.');
  return lastDotIndex !== -1 ? fileName.substring(lastDotIndex) : '';
};

// Get file name without extension
export const getFileNameWithoutExtension = (fileName) => {
  const lastDotIndex = fileName.lastIndexOf('.');
  return lastDotIndex !== -1 ? fileName.substring(0, lastDotIndex) : fileName;
};

// Format file size
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}; 